module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-sa"
  }, [_c('div', {
    staticClass: "sign"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sign_cont"
  }, [_c('div', {
    staticClass: "agreement"
  }, [_c('div', {
    staticClass: "cont_agree"
  }, [_c('img', {
    attrs: {
      "src": _vm.saImgPath,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "annex-link",
    attrs: {
      "href": _vm.annexPath,
      "target": "_blank"
    }
  }, [_vm._v("Annex")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.complete),
      expression: "!complete"
    }],
    staticClass: "checkInput"
  }, [_c('InputCheckbox', {
    attrs: {
      "isCheck": _vm.isCheck
    },
    on: {
      "checkFn": _vm.changeCheck
    }
  }), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.complete && _vm.isCheck),
      expression: "!complete && isCheck"
    }],
    staticClass: "clearfix c_wrap",
    class: [{
      hide: !_vm.isCheck
    }, 'line_f']
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.first_name),
      expression: "first_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "First Name＊"
    },
    domProps: {
      "value": (_vm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.full_name),
      expression: "full_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Last Name＊"
    },
    domProps: {
      "value": (_vm.full_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.full_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Nationality"
    },
    model: {
      value: (_vm.country),
      callback: function($$v) {
        _vm.country = $$v
      },
      expression: "country"
    }
  }, _vm._l((_vm.datas), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "textInput clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.nick_name),
      expression: "nick_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Teacher Name*"
    },
    domProps: {
      "value": (_vm.nick_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nick_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "detect",
    on: {
      "click": _vm.detectFn
    }
  }, [_vm._v("Detect Availability")]), _vm._v(" "), _c('p', {
    class: [{
      great: _vm.great
    }, 'state_notice']
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "btn_wrap"
  }, [_c('a', {
    class: {
      'dis': !_vm.canSetSa
    },
    on: {
      "click": _vm.setSa
    }
  }, [_vm._v("I Agree")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.complete),
      expression: "complete"
    }],
    staticClass: "complete"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.first_name) + " " + _vm._s(_vm.full_name) + " / " + _vm._s(_vm.datas[_vm.country]) + " / " + _vm._s(_vm.nick_name))]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date))])])])]), _vm._v(" "), _c('div', {
    staticClass: "next_cont"
  }, [_c('a', {
    staticClass: "button",
    class: {
      cancel: !_vm.complete
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Next")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('span', [_vm._v("Sign the service agreement")]), _vm._v(" "), _c('a', {
    staticClass: "hide",
    attrs: {
      "href": "javascript:;",
      "target": "_blank"
    }
  }, [_vm._v("Service agreement FAQs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "checkCont"
  }, [_vm._v("By clicking here, I indicate that I have read, understood, and accepted the terms "), _c('br'), _vm._v("and conditions of my service agreement with 51Talk EnglishInternational Limited.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attention"
  }, [_c('i'), _vm._v(" "), _c('p', [_c('b'), _vm._v("Teacher Naming Standards "), _c('br'), _vm._v("·Must be unique and not yet used by other teachers in the system.\n              "), _c('br'), _vm._v("·Must consist of two full names, not initials (i.e. Aaron James). "), _c('br'), _vm._v("·May contain your original name or a name that sounds like it but the second name must be an alias."), _c('br'), _vm._v("·Must not sound funny or awkward (i.e. Superman, Bubble Tea)."), _c('br'), _vm._v("·Videos, introductions, and Skype accounts must use the same teacher name.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span'), _vm._v("Agreed")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d55acbcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/onboarding/sign_sa.vue
// module id = 866
// module chunks = 1